import { Copy, X } from "lucide-react";
import { useState } from "react";

/** Variables del .env de un server local. El secreto se muestra una sola vez:
 *  el cloud no lo guarda (lo deriva), si se pierde hay que rotarlo. */
export function CredentialsDialog({
  title,
  env,
  onClose,
}: {
  title: string;
  env: Record<string, string>;
  onClose: () => void;
}) {
  const text = Object.entries(env)
    .map(([k, v]) => `${k}=${v}`)
    .join("\n");
  const [copied, setCopied] = useState(false);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 p-4">
      <div className="w-full max-w-xl space-y-3 rounded-2xl bg-white p-6 shadow-xl">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="Cerrar"
            className="rounded-lg p-1 hover:bg-slate-100"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <p className="text-sm text-amber-800">
          Cópialas ahora en el .env del servidor local: el secreto no se vuelve a mostrar (si se
          pierde, rota el secreto desde la empresa).
        </p>
        <pre className="overflow-x-auto rounded-lg bg-slate-900 p-3 text-xs text-slate-100">{text}</pre>
        <button
          type="button"
          onClick={() => {
            void navigator.clipboard.writeText(text).then(() => setCopied(true));
          }}
          className="flex items-center gap-1 rounded-lg bg-brand-600 px-3 py-2 text-sm font-semibold text-white hover:bg-brand-700"
        >
          <Copy className="h-4 w-4" /> {copied ? "Copiado" : "Copiar"}
        </button>
      </div>
    </div>
  );
}
